import Vue from 'global-vue'

import di from 'di'

import { Session } from '@wittignl/js-core/plugins/Authentication'

import createQuery from '@wittignl/js-core/apollo/queries/createQuery'

import InitQuery from 'gql/queries/Init.gql'

import getUrlParams from '@wittignl/js-core/utils/getUrlParams'
import { decode as decodeBase64 } from '@wittignl/js-core/utils/base64'

import clone from 'lodash/clone'


export default class RelayAccountType
{
    static NAME = 'relay';

    async login({ relayData }) {

        if(!relayData || !relayData.token || !relayData.expiration || !relayData.start){
            throw 'No/invalid relay data received';
        }

        const apollo = di.get('apollo');
        const initResult = await apollo.query(createQuery(InitQuery, {

            context: {
                headers: {
                    Authorization: `Bearer ${relayData.token}`
                }
            }
        }));

        if(!initResult || !initResult.data || !initResult.data.viewer.user){
            throw 'Invalid init response';
        }

        const user = clone(initResult.data.viewer.user);

        return new Session(RelayAccountType.NAME, user, relayData.start, relayData.expiration, relayData.token);
    }

    authenticate(identity) {

        return Promise.resolve();
    }

    logout(session) {

        return Promise.resolve();
    }

    static loginIfNeeded(){

        const urlParams = getUrlParams(window.location.search);
        const relay = urlParams.relay ? decodeBase64(urlParams.relay) : null;
        const relayData = relay ? JSON.parse(relay) : null;

        if(!relayData) {
            return Promise.resolve(false);
        }

        di.get('logger').info('RelayAccountType', 'Logging in via relay');

        return di.get('auth').login(RelayAccountType.NAME, { relayData });
    }
}
